'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// D:/agent/4/_work/121/s/common/~/querystring/index.js
// module id = 158
// module chunks = 0